import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enCommon from '@/locales/en/common.json';
import enAuth from '@/locales/en/auth.json';
import enProjects from '@/locales/en/projects.json';
import enRecommendations from '@/locales/en/recommendations.json';
import enDeployments from '@/locales/en/deployments.json';
import enModels from '@/locales/en/models.json';
import enModelAdvisor from '@/locales/en/modelAdvisor.json';
import enGpuExplorer from '@/locales/en/gpuExplorer.json';
import enAdmin from '@/locales/en/admin.json';
import enSettings from '@/locales/en/settings.json';
import enBilling from '@/locales/en/billing.json';
import enErrors from '@/locales/en/errors.json';

export const SUPPORTED_LANGUAGES = ['en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_NAMESPACE = 'common';
export const NAMESPACES = [
  'common',
  'auth',
  'projects',
  'recommendations',
  'deployments',
  'models',
  'modelAdvisor',
  'gpuExplorer',
  'admin',
  'settings',
  'billing',
  'errors',
] as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        projects: enProjects,
        recommendations: enRecommendations,
        deployments: enDeployments,
        models: enModels,
        modelAdvisor: enModelAdvisor,
        gpuExplorer: enGpuExplorer,
        admin: enAdmin,
        settings: enSettings,
        billing: enBilling,
        errors: enErrors,
      },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    defaultNS: DEFAULT_NAMESPACE,
    ns: NAMESPACES as unknown as string[],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'lang',
    },
    // Resources are bundled synchronously above — no async loading needed,
    // so disabling Suspense keeps tests + first paint render-stable.
    react: { useSuspense: false },
  });

export default i18n;
